<template>
    <div class="sidebar">
        <el-menu
            class="sidebar-el-menu"
            :default-active="onRoutes"
            :collapse="collapse"
            background-color="#242f42"
            text-color="#fff"
            active-text-color="#66b1ff"
            unique-opened
            router
        >
            <template v-for="item in items">
                <template v-if="item.subs">
                    <el-submenu :index="item.index ? item.index : item.id.toString()" :key="item.id">
                        <template slot="title">
                            <i :class="item.icon"></i>
                            <span slot="title">{{ item.title }}</span>
                        </template>
                        <template v-for="subItem in item.subs">
                            <el-submenu
                                v-if="subItem.subs"
                                :index="subItem.index ? subItem.index : subItem.id.toString()"
                                :key="subItem.id"
                            >
                                <template slot="title">{{ subItem.title }}</template>
                                <el-menu-item
                                    v-for="threeItem in subItem.subs"
                                    :key="threeItem.id"
                                    :index="threeItem.index ? threeItem.index : threeItem.id.toString()"
                                    >{{ threeItem.title }}</el-menu-item
                                >
                            </el-submenu>
                            <el-menu-item v-else :index="subItem.index ? subItem.index : subItem.id.toString()" :key="subItem.id">{{
                                subItem.title
                            }}</el-menu-item>
                        </template>
                    </el-submenu>
                </template>
                <template v-else>
                    <el-menu-item :index="item.index ? item.index : item.id.toString()" :key="item.id">
                        <i :class="item.icon"></i>
                        <span slot="title">{{ item.title }}</span>
                    </el-menu-item>
                </template>
            </template>
        </el-menu>
    </div>
</template>

<script>
import bus from '../common/bus';
export default {
    name: 'sidebar',
    data() {
        return {
            collapse: false,
            items: [],
            index: ''
        };
    },
    computed: {
        onRoutes() {
            return this.$route.path.replace('/', '');
        }
    },
    created() {
        this.items = JSON.parse(localStorage.getItem('adminMenus'));
        // 通过 Event Bus 进行组件间通信，来折叠侧边栏
        this.$bus.$on('collapse', (msg) => {
            this.collapse = msg;
            this.$bus.$emit('collapse-content', msg);
        });
    },
    mounted() {
        this.index = this.$route.name;
    }
};
</script>

<style scoped lang="scss">
.sidebar {
    display: block;
    position: absolute;
    left: 0;
    top: 50px;
    bottom: 0;
    overflow-y: scroll;
}
.sidebar::-webkit-scrollbar {
    width: 0;
}
.sidebar-el-menu:not(.el-menu--collapse) {
    width: 150px;
}
.sidebar > ul {
    height: 100%;
}
</style>
